module.exports = __webpack_public_path__ + "static/img/RADIN_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RADIN_1.png
// module id = xTvf
// module chunks = 0